'use client';

import { useEffect } from 'react';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service

  }, [error]);

  return (
    <html lang="en" suppressHydrationWarning>
      <body className="antialiased font-sans">
        <div className="min-h-screen bg-black dark:bg-black flex items-center justify-center">
          <div className="text-center max-w-2xl mx-auto px-4">
            <h1 className="text-6xl font-bold text-white mb-4">500</h1>
            <h2 className="text-2xl font-semibold text-white mb-4">Something went wrong!</h2>
            <p className="text-xl text-gray-400 mb-8">
              {error.message || 'An unexpected error occurred'}
            </p>
            <button
              onClick={reset}
              className="px-6 py-3 bg-white text-black rounded-lg hover:bg-gray-100 transition-colors font-semibold"
            >
              Try again
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}

